<template>
  <div class="books-details">
    <p class="box-title">审核资质</p>
    <!-- 内容 -->

    <div class="inputBox">
      <el-input
        v-model="mydata.query_code"
        style="width: 240px"
        placeholder="请输入查询码"
        @keyup.enter="queryCodeFn"
      />
      <el-button type="primary" class="box1" @click="queryCodeFn"
        >查询进度</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import { reactive, computed } from "vue";
// import { ElMessage } from 'element-plus'
import { ComponentSize, FormInstance, FormRules } from "element-plus";

import {
  Delete,
  Download,
  Plus,
  ZoomIn,
  Warning,
} from "@element-plus/icons-vue";

import { UploadFile } from "element-plus";

import dayjs from "dayjs";

// 引入申请状态查询
import { queryCode } from "@/api/distributionAuthorization/authorizedOnlineShop/queryProgressStep/index.js";

const router = useRouter();

const mydata = reactive({
  query_code: "",
});

//申请状态查询
function queryCodeFn() {
  queryCode({
    query_code: mydata.query_code,
  }).then((res) => {
    // console.log(res.data, "申请状态查询");
    // console.log(res.data);
    // 跳转页面
    router.push({
      path: "/layout/list/progressStep",
      query: {
        step: res.data.status + 1,
        data: JSON.stringify(res.data),
      },
    });
  });
}

//点击事件
// function onlineShopDetailsButton() {
//   router.push({
//     path: "/layout/list/onlineShopDetails",
//   });
// }

// const submitForm = async (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   await formEl.validate((valid, fields) => {
//     if (valid) {
//       console.log('submit!')
//     } else {
//       console.log('error submit!', fields)
//     }
//   })
// }

// const resetForm = (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   formEl.resetFields()
// }

// const options = Array.from({ length: 10000 }).map((_, idx) => ({
//   value: `${idx + 1}`,
//   label: `${idx + 1}`,
// }))

// const handleRemove = (file) => {
//   console.log(file)
// }

// const handlePictureCardPreview = (file) => {
//   dialogImageUrl.value = file.url!
//   dialogVisible.value = true
// }

// const handleDownload = (file) => {
//   console.log(file)
// }
</script>

<style scoped lang="scss">
.books-details {
  width: 343px;
  height: 450px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 40px;
  padding: 20px 16px;
  border-radius: 8px;
  // border: 1px solid red;
  background-color: #ffffff;

  
  //////内容   ////////////////////////////////////
 
  .box-title {
    font-size: 18px;
    font-weight: 700;
    color: #333333;
  }
  .inputBox {
     margin-top:123px;
    // border:1px solid red;
    //////输入框
    :deep(.el-input) {
      width: 237px !important;
      height: 34px;
      border-radius: 8px 0px 0px 8px !important;
      // border: 1px solid blue;
    }
    /////输入框边框
    :deep(.el-input__wrapper) {
      // border:1px solid blue;
      border-radius: 8px 0px 0px 8px !important;
    }
    //////两个按钮
    :deep(.el-button.el-button--primary) {
      // border:1px solid rgb(255, 0, 0);
      width: 74px;
      height: 34px;
      border-radius: 0px 8px 8px 0px;
      > span {
        font-size: 14px;
        font-weight: 350;
        color: #ffffff;
      }
    }
    // //////第一个按钮
    // :deep(.el-button.el-button--primary.box1) {
    //   // border:1px solid rgb(17, 255, 0);
    //   width: 113px;
    //   border-radius: 0px 8px 8px 0px;
    // }
  }
  
}
</style>